/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImuTapSequenceCompletePayload
 */
export interface ImuTapSequenceCompletePayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: ImuTapSequenceCompletePayloadTypeEnum;
}


/**
 * @export
 */
export const ImuTapSequenceCompletePayloadTypeEnum = {
    ImuTapSequenceComplete: 'imu_tap_sequence_complete',
} as const;
export type ImuTapSequenceCompletePayloadTypeEnum = typeof ImuTapSequenceCompletePayloadTypeEnum[keyof typeof ImuTapSequenceCompletePayloadTypeEnum];


/**
 * Check if a given object implements the ImuTapSequenceCompletePayload interface.
 */
export function instanceOfImuTapSequenceCompletePayload(value: object): value is ImuTapSequenceCompletePayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'imu_tap_sequence_complete') return false;
    
    return true;
}

export function ImuTapSequenceCompletePayloadFromJSON(json: any): ImuTapSequenceCompletePayload {
    return ImuTapSequenceCompletePayloadFromJSONTyped(json, false);
}

export function ImuTapSequenceCompletePayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImuTapSequenceCompletePayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
    };
}

export function ImuTapSequenceCompletePayloadToJSON(json: any): ImuTapSequenceCompletePayload {
    return ImuTapSequenceCompletePayloadToJSONTyped(json, false);
}

export function ImuTapSequenceCompletePayloadToJSONTyped(value?: ImuTapSequenceCompletePayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
    };
}

